import { useCallback } from 'react';
import type { BlockerFunction } from 'react-router-dom';

import { FormPrompt } from '../ConfirmBeforeExitForm/FormPrompt';

import { useDocumentEditorContext } from './contexts/DocumentEditorContext/hooks/useDocumentEditorContext.hook';

export const NavigationBlocker = () => {
  const {
    props: {
      routerSettings: { editorModePaths },
    },
    state: { currentVersion, latestSavedVersion },
  } = useDocumentEditorContext();

  const mustBlock = useCallback<BlockerFunction>(
    ({ nextLocation }) =>
      !Object.values(editorModePaths).includes(nextLocation.pathname) &&
      currentVersion > 0 &&
      currentVersion !== latestSavedVersion,
    [currentVersion, editorModePaths, latestSavedVersion],
  );

  return <FormPrompt mustBlock={mustBlock} />;
};
